import { Injectable } from '@angular/core';
import { QuestionnarieDataService } from '../api/questionnarie-data.service';

@Injectable({
    providedIn: 'root'
})

export class QuestionnarieService {
    constructor(private questionnarieDataService: QuestionnarieDataService) { }

    // Add Questionnarie form
    public addQuestionnarie(data) {
        return this.questionnarieDataService.addQuestionnarie(data);
    }

    // Get All Questionnarie Form Data
    public getAllQuestionnarie() {
        return this.questionnarieDataService.getAllQuestionnarie();
    }

    // Get Qustionnarie  based on student id 
    public getQuestionnarieByStudentById(data: any) {
        return this.questionnarieDataService.getQuestionnarieByStudentById(data);
    }

    // get all questionnarie form data 
    public getAllQuestionnarieList(data: any) {
        return this.questionnarieDataService.getAllQuestionnarieList(data);
    }
    // save dynaqmic questionnarie form
    public saveDynamicQuestionnarie(data: any) {
        return this.questionnarieDataService.saveDynamicQuestionnarie(data);
    }

    // assign questionnarie to institution
    public assignQuestionnarieToInstitution(data: any) {
        return this.questionnarieDataService.assignQuestionnaireFormToInstitution(data);
    }

    // view questionnarie form details by id
    public viewQuestionnarieFormDetailsById(questionnarieId: any) {
        return this.questionnarieDataService.viewQuestionnarieFormDetailsById(questionnarieId);
    }

    // edit questionnarie form
    public editDynamicQuestionnarie(data: any, id: any) {
        return this.questionnarieDataService.editDynamicQuestionnarie(data, id);
    }

    // Check PDF Conversion
    public checkPdf(data: any) {
        return this.questionnarieDataService.checkPdf(data)
    }
}